export default __webpack_public_path__ + "static/media/apvs-material-7.f52720a5.webp";